import React from 'react';
import { getScoreCardTooltipTabledata } from '../helper';
import {
    Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { COLOR_PRIMARY_1 } from 'src/colors';

const ScoreTooltip = ({ market, currency }) => {
  let rowData = getScoreCardTooltipTabledata(market, currency);
  return (
    <Box sx={{ width: '100%', padding: '10px' }}>
      <Typography sx={{ fontWeight: 500, fontSize: '12px', paddingBottom: '10px' }}>
        Projected Wealth Creation Over 10 Years: ROI of {market.ten_years_roi}x
      </Typography>
      <Box sx={{ width: '93%' }}>
        <TableContainer component={Paper}>
          <Table sx={{ maxWidth: '100%', borderRadius: '5px' }} aria-label="customized table">
            <TableHead sx={{ backgroundColor: COLOR_PRIMARY_1 }}>
              <TableRow>
                <TableCell align="left" sx={{ padding: '5px', maxWidth: 'none' }}>
                  <Typography style={{ fontSize: '12px', fontWeight: 500, color: '#fff' }}>
                    Year
                  </Typography>
                </TableCell>
                <TableCell align="left" sx={{ padding: '5px', maxWidth: 'none' }}>
                  <Typography style={{ fontSize: '12px', fontWeight: 500, color: '#fff' }}>
                    Property Price
                  </Typography>
                </TableCell>
                <TableCell align="left" sx={{ padding: '5px', maxWidth: 'none' }}>
                  <Typography style={{ fontSize: '12px', fontWeight: 500, color: '#fff' }}>
                    Total Profit
                  </Typography>
                </TableCell>
                <TableCell align="left" sx={{ padding: '5px', maxWidth: 'none' }}>
                  <Typography style={{ fontSize: '12px', fontWeight: 500, color: '#fff' }}>
                    Total Wealth
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rowData.map((row, index) => (
                <TableRow
                  key={row.name}
                  sx={{
                    '&:last-child td, &:last-child th': { border: 0 },
                    backgroundColor: index % 2 === 0 ? 'white' : '#f8f8f8',
                  }}
                >
                  <TableCell align="left" sx={{ padding: '5px', maxWidth: 'none' }}>
                    <Typography style={{ fontSize: '12px' }}>{row.year}</Typography>
                  </TableCell>
                  <TableCell align="left" sx={{ padding: '5px', maxWidth: 'none' }}>
                    <Typography style={{ fontSize: '12px' }}>{row.property_price}</Typography>
                  </TableCell>
                  <TableCell align="left" sx={{ padding: '5px', maxWidth: 'none' }}>
                    <Typography style={{ fontSize: '12px' }}>{row.total_profit}</Typography>
                  </TableCell>
                  <TableCell align="left" sx={{ padding: '5px', maxWidth: 'none' }}>
                    <Typography style={{ fontSize: '12px' }}>{row.total_wealth}</Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default ScoreTooltip;
